import moment from 'moment';

export const SHARE_ACCESS_TYPES = {
  FULL: 'FULL',
  SELECTIVE: 'SELECTIVE',
  TIMEFRAME: 'TIMEFRAME'
};

export const SHARE_ACCESS_TYPE_LABELS = {
  [SHARE_ACCESS_TYPES.FULL]: 'Full access',
  [SHARE_ACCESS_TYPES.SELECTIVE]: 'Selective',
  [SHARE_ACCESS_TYPES.TIMEFRAME]: 'Timeframe'
};

export const SHARE_ACCESS_TYPE_OPTIONS = [
  {
    value: SHARE_ACCESS_TYPES.FULL,
    label: SHARE_ACCESS_TYPE_LABELS[SHARE_ACCESS_TYPES.FULL]
  },
  {
    value: SHARE_ACCESS_TYPES.SELECTIVE,
    label: SHARE_ACCESS_TYPE_LABELS[SHARE_ACCESS_TYPES.SELECTIVE]
  },
  {
    value: SHARE_ACCESS_TYPES.TIMEFRAME,
    label: SHARE_ACCESS_TYPE_LABELS[SHARE_ACCESS_TYPES.TIMEFRAME]
  }
];

export const SHARE_ACCESS_FORM_DEFAULTS = {
  accessType: SHARE_ACCESS_TYPES.SELECTIVE,
  scopeFromDate: '',
  scopeToDate: ''
};

export const dateToScopeFromUtc = dateStr => {
  if (!dateStr) return undefined;
  const m = moment.utc(dateStr, 'YYYY-MM-DD', true);
  if (!m.isValid()) return undefined;
  return `${m.format('YYYY-MM-DD')}T00:00:00Z`;
};

export const dateToScopeToUtc = dateStr => {
  if (!dateStr) return undefined;
  const m = moment.utc(dateStr, 'YYYY-MM-DD', true);
  if (!m.isValid()) return undefined;
  return `${m.format('YYYY-MM-DD')}T23:59:59Z`;
};

export const validateShareRequestAccess = (
  accessType,
  scopeFromDate,
  scopeToDate
) => {
  if (accessType !== SHARE_ACCESS_TYPES.TIMEFRAME) {
    return { valid: true };
  }
  if (!scopeFromDate && !scopeToDate) {
    return {
      valid: false,
      message: 'Please select at least a start date or an end date.'
    };
  }
  if (scopeFromDate && scopeToDate && scopeFromDate > scopeToDate) {
    return {
      valid: false,
      message: 'Start date must be before end date.'
    };
  }
  return { valid: true };
};

export const buildShareRequestAccessPayload = (
  accessType,
  { scopeFromDate, scopeToDate } = {}
) => {
  switch (accessType) {
    case SHARE_ACCESS_TYPES.FULL:
      return {
        RequestType: 'CONNECT',
        ShareAll: true
      };
    case SHARE_ACCESS_TYPES.SELECTIVE:
      return {
        RequestType: 'ENTRYREQUEST',
        ShareAll: false,
        ScopeType: 'SELECTIVE'
      };
    case SHARE_ACCESS_TYPES.TIMEFRAME: {
      const payload = {
        RequestType: 'ENTRYREQUEST',
        ShareAll: false
      };
      const scopeFromUtc = dateToScopeFromUtc(scopeFromDate);
      const scopeToUtc = dateToScopeToUtc(scopeToDate);
      if (scopeFromUtc) payload.ScopeFromUtc = scopeFromUtc;
      if (scopeToUtc) payload.ScopeToUtc = scopeToUtc;
      return payload;
    }
    default:
      return {
        RequestType: 'CONNECT',
        ShareAll: true
      };
  }
};
